import React from 'react'
import { useSelector } from 'react-redux'
import { CardTextBlock } from '../../components/cards/CardTextBlock'
import styles from './TrainTable.module.scss'

export function TableTrainerBoard({ toggleBoardModal, isSettings, mockBoard, mockQuery, style = {} }) {
	const { board: reduxBoard, activeQuery: query } = useSelector((state) => state.view)

	const board = isSettings ? mockBoard : reduxBoard
	const activeQuery = isSettings ? mockQuery : query

	const flopCards = board.slice(0, 3)
	const turnCards = board[3]
	const riverCards = board[4]

	const isFlop = activeQuery && activeQuery.includes('F.')
	const isTurn = activeQuery && activeQuery.includes('T.')
	const isRiver = activeQuery && activeQuery.includes('R.')

	return (
		<div className={styles.cardsBlockWrapper} style={style}>
			<div className={styles.cardsRow} onClick={toggleBoardModal}>
				{isFlop &&
					flopCards[0] !== '-' &&
					flopCards.map((el) => (
						<div key={el}>
							<CardTextBlock cards={el} isFullWidth isSquare />
						</div>
					))}

				{isTurn && turnCards !== '-' && (
					<div>
						<CardTextBlock cards={turnCards} isFullWidth isSquare />
					</div>
				)}

				{isRiver && riverCards !== '-' && (
					<div>
						<CardTextBlock cards={riverCards} isFullWidth isSquare />
					</div>
				)}
			</div>
		</div>
	)
}
